import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import debug from 'debug'
import { signOut } from 'next-auth/react'
import posthog from 'posthog-js'
import { isBrowser } from '../../utils/is.browser'
import { setCompanyId } from '../company'
import { AppDispatch, State } from '../index'

const logger = debug('store:auth')

export const authSlice = createSlice({
  initialState: {
    authenticated: false as boolean,
    email: undefined as string,
    initialized: false as boolean,
    roles: [] as string[],
  },
  name: 'auth',

  reducers: {
    init: (state, action: PayloadAction<{
      email: string | false
      roles?: string[]
    }>) => {
      const roles = action.payload.roles || []
      const email = action.payload.email

      if (email) {
        localStorage.setItem('email', email)
        localStorage.setItem('roles', JSON.stringify(roles))
      }

      return {
        authenticated: Boolean(email),
        email: email !== false ? email : undefined,
        initialized: true,
        roles,
      }
    },
    login: (state, action: PayloadAction<{
      authenticated: boolean
      email: string
      roles?: string[]
    }>) => {
      const { authenticated, email, roles} = action.payload
      return {
        authenticated,
        email: email ? email : undefined,
        initialized: true,
        roles: roles || [],
      }
    },
    removeToken: () => {
      if (!isBrowser()) {
        logger('DANGER!!! called removeToken in SSR')

        return
      }

      logger('remove token and force logout')
      posthog.reset()
      localStorage.clear()
      sessionStorage.clear()

      void signOut({
        redirectTo: '/app',
      })

      return {
        authenticated: false,
        email: undefined,
        initialized: true,
        roles: [],
      }
    },
    setRoles: (state, action: PayloadAction<string[]>) => {
      const roles = action.payload || []

      return {
        ...state,
        roles,
      }
    },
    triggerLogin: (state) => {
      return {
        ...state,
        authenticated: true,
      }
    },
  },
})

export const { triggerLogin, init, setRoles, removeToken } = authSlice.actions

export const logout = createAsyncThunk<void, void, {
  dispatch: AppDispatch
  state: State
}>(
  'auth/logout',
  (payload, thunkAPI) => {
    thunkAPI.dispatch(removeToken())
    thunkAPI.dispatch(setCompanyId())
  })
